import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const WP_BASE = 'https://falcon-fishing.net/wp/wp-json/wp/v2';

export default function PrivacyPolicyPage() {
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${WP_BASE}/pages?slug=privacy-policy-2`)
      .then(r => r.json())
      .then(data => {
        if (data && data[0]) {
          setTitle(data[0].title.rendered);
          setContent(data[0].content.rendered);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <style>{`
        .pp-page { background: #000; min-height: 100vh; padding-top: 100px; }
        .pp-inner { max-width: 860px; margin: 0 auto; padding: 60px 40px 100px; }
        .pp-title { font-family: 'Alumni Sans', sans-serif; font-weight: 500; font-size: 64px; line-height: 58px; color: #fff; margin-bottom: 48px; }
        .pp-body { font-family: 'Roboto', sans-serif; font-weight: 300; font-size: 16px; color: rgba(255,255,255,0.85); line-height: 1.75; }
        .pp-body h1, .pp-body h2, .pp-body h3 { font-family: 'Alumni Sans', sans-serif; font-weight: 500; color: #fff; margin: 32px 0 12px; }
        .pp-body h1 { font-size: 40px; }
        .pp-body h2 { font-size: 32px; }
        .pp-body h3 { font-size: 24px; }
        .pp-body a { color: #d71921; }
        .pp-body p { margin-bottom: 16px; }
        .pp-loading { text-align: center; padding: 120px 20px; font-family: 'Alumni Sans', sans-serif; font-size: 26px; color: rgba(255,255,255,0.4); }
        @media (max-width: 600px) {
          .pp-inner { padding: 40px 20px 80px; }
          .pp-title { font-size: 44px; line-height: 40px; }
        }
      `}</style>

      <div className="pp-page">
        <Navbar />
        <div className="pp-inner">
          {loading ? (
            <div className="pp-loading">Caricamento...</div>
          ) : content ? (
            <>
              <h1 className="pp-title" dangerouslySetInnerHTML={{ __html: title }} />
              <div className="pp-body" dangerouslySetInnerHTML={{ __html: content }} />
            </>
          ) : (
            <div className="pp-loading">Contenuto non trovato. Verifica che la pagina sia pubblicata su WordPress.</div>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
}
